<template>
  <div>
    <div
      @click="handleShowSelector"
      style="border-bottom: 1px solid #c7c7c7; padding: 5px 15px;"
    >
      <van-icon name="location-o" style="margin-right: 15px;" />
      <span v-bind:class="classObject">{{ valueStr }}</span>
    </div>
    <van-popup
      v-if="!readonly"
      v-model="visible"
      position="bottom"
      get-container="body"
      round
      safe-area-inset-bottom
    >
      <van-area
        :value="valueCode"
        :area-list="areaList"
        :loading="loading"
        @confirm="handleChange"
        @change="handleSelected"
        @cancel="handleCancel"
      />
    </van-popup>
  </div>
</template>
<script>
import { Popup, Area, Icon } from "vant";
import { AreaSharedCache } from "@/utils/AreaSharedCache.ts";

export default {
  name: "area-single-selector-mobile",
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Area.name]: Area,
  },
  props: {
    value: Array,
    readonly: Boolean,
    placeholder: {
      type: String,
      default: "请选择地区",
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      visible: false,
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {},
      },
      codeMap: {},
      valueStr: "",
      valueCode: "",
      loading: false,
    };
  },
  computed: {
    classObject() {
      const { value } = this.$props;
      const hasValue = Array.isArray(value) && value.length;
      return { "clr-grey": !hasValue };
    },
  },
  watch: {
    value(array) {
      this.buildValueStr(array).then((it) => (this.valueStr = it));
    },
    readonly() {
      this.loadChildren(0, 0);
    },
  },
  methods: {
    handleShowSelector() {
      if (this.readonly) {
        return;
      }
      this.visible = true;
    },
    async handleSelected(instance, value, index) {
      const { code } = value[index];
      const id = this.codeMap[code];
      if (index > 1) {
        return;
      }
      const items = await this.loadChildren(id, index + 1);
      if (index > 0) {
        return;
      }
      //选择省的时候 除了加载市  还要自动加载县
      const item = items[0];
      if (item) {
        await this.loadChildren(item.id, index + 2);
      }
    },
    handleChange(array) {
      const value = array.filter((it) => it).map((it) => this.codeMap[it.code]);
      const event = "change";
      if (this.$listeners[event]) {
        this.$emit(event, value);
      }
      this.handleCancel();
    },
    handleCancel() {
      this.visible = false;
    },
    async buildValueStr(valueArray) {
      const { value, readonly, placeholder } = this.$props;
      const array = valueArray === undefined ? value : valueArray;
      if (!Array.isArray(array) || !array.length) {
        return placeholder;
      }
      if (readonly) {
        await AreaSharedCache.loadByList(array);
      } else {
        await AreaSharedCache.loadChildrenByList(array.concat(0));
      }
      if (array[0]) {
        await this.loadChildren(array[0], 1);
      }
      if (array[1]) {
        await this.loadChildren(array[1], 2);
      }
      this.valueCode = array
        .map((it) => {
          const item = AreaSharedCache.getItem(it);
          return item ? item.fullCode : it;
        })
        .pop();
      return array
        .map((it) => {
          const item = AreaSharedCache.getItem(it);
          return item ? item.name : it;
        })
        .join("/");
    },
    async loadChildren(id, level) {
      this.loading = true;
      const items = await AreaSharedCache.loadChildren(id);
      const obj = {};
      items.forEach((it) => {
        obj[it.fullCode] = it.name;
        this.codeMap[it.fullCode] = it.id;
      });
      if (level === 0) {
        this.areaList.province_list = obj;
      } else if (level === 1) {
        this.areaList.city_list = obj;
      } else if (level === 2) {
        this.areaList.county_list = obj;
      }
      this.loading = false;
      return items;
    },
  },
  async mounted() {
    if (!this.readonly) {
      const items = await this.loadChildren(0, 0);
      if (Array.isArray(items) && items.length) {
        const item = items[0];
        if (item) {
          await this.handleSelected({}, [{ code: item.fullCode }], 0);
          // await this.loadChildren(item.id, 1);
        }
      }
    }
    this.valueStr = await this.buildValueStr();
  },
};
</script>
<style scoped>
.area-single-selector>>.el-cascader-panel
  > .el-cascader-menu
  > .el-cascader-menu__wrap {
  height: 400px;
}
</style>
